<template>
    <input type="datetime-local" class="form-control" v-model="date" @change="filterChange">
</template>

<script>
import CtkDateTimePicker from 'vue-ctk-date-time-picker';
export default {
    components: {
        CtkDateTimePicker
    },
    data () {
        return {
            date: '',
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Utils/CalendarFilter.vue